import React, { FC, useState } from 'react';
import { MdSubject as NoteIcon } from '@react-icons/all-files/md/MdSubject';
import { MdAccessAlarm as ReminderIcon } from '@react-icons/all-files/md/MdAccessAlarm';
import { MdEvent as AppointmentIcon } from '@react-icons/all-files/md/MdEvent';
import { MdFormatListBulleted as TaskIcon } from '@react-icons/all-files/md/MdFormatListBulleted';
import Action from './components/Action';
import { createUseStyles } from 'src/theming';
import clsx from 'clsx';
import AddAppointmentDialog from 'src/components/CollaborativePlanning/Dialog';
import {
  CollaborativeSource,
  CreateAppointmentOptions,
  CreateNoteOptions,
  CreateReminderOptions,
  CreateTaskOptions,
} from 'src/interfaces/api/Collaborative';
import AddNoteDialog from 'src/components/CollaborativePlanning/Dialog/components/AddNoteDialog';
import AddReminderDialog from '../../../../../../components/CollaborativePlanning/Dialog/components/AddReminderDialog';
import AddTaskDialog from '../../../../../../components/CollaborativePlanning/Dialog/components/AddTaskDialog';

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
  },
});

interface Props {
  className?: string;
  collaborativeSource: CollaborativeSource;
  onAddAppointment: (options: CreateAppointmentOptions) => void;
  onAddNote: (options: CreateNoteOptions) => void;
  onAddReminder: (options: CreateReminderOptions) => void;
  onAddTask: (options: CreateTaskOptions) => void;
}

const PlanningAction: FC<Props> = ({
  className,
  collaborativeSource,
  onAddAppointment,
  onAddNote,
  onAddReminder,
  onAddTask,
  ...props
}) => {
  const [isAppointmentDialogOpen, setIsAppointmentDialogOpen] = useState(false);
  const [isReminderDialogOpen, setIsReminderDialogOpen] = useState(false);
  const [isNoteDialogOpen, setIsNoteDialogOpen] = useState(false);
  const [isTaskDialogOpen, setIsTaskDialogOpen] = useState(false);
  const classes = useStyles();

  return (
    <>
      <div className={clsx(classes.root, className)} {...props}>
        <Action label='Rendez-vous' icon={AppointmentIcon} onClick={() => setIsAppointmentDialogOpen(true)} />
        <Action label='Note' icon={NoteIcon} onClick={() => setIsNoteDialogOpen(true)} />
        <Action label='Rappel' icon={ReminderIcon} onClick={() => setIsReminderDialogOpen(true)} />
        <Action label='Tâche' icon={TaskIcon} onClick={() => setIsTaskDialogOpen(true)} />
      </div>

      <AddAppointmentDialog
        appointmentSource={collaborativeSource}
        onClose={() => setIsAppointmentDialogOpen(false)}
        open={isAppointmentDialogOpen}
        onValidate={onAddAppointment}
      />

      <AddNoteDialog
        noteSource={collaborativeSource}
        onClose={() => setIsNoteDialogOpen(false)}
        open={isNoteDialogOpen}
        onValidate={onAddNote}
      />

      <AddReminderDialog
        reminderSource={collaborativeSource}
        onClose={() => setIsReminderDialogOpen(false)}
        open={isReminderDialogOpen}
        onValidate={onAddReminder}
      />

      <AddTaskDialog
        taskSource={collaborativeSource}
        onClose={() => setIsTaskDialogOpen(false)}
        open={isTaskDialogOpen}
        onValidate={onAddTask}
      />
    </>
  );
};

export default PlanningAction;
